<template>
  <div class="cart-outer-wrapper" style="display: flex; flex-wrap: wrap; width:100%">
    <adv-cart-product-row
      v-for="(cartProduct, index) in cartProductContents"
      :key="index"
      :mini-cart="miniCart"
      :read-only="readOnly"
      :disable-product-links="disableProductLinks"
      :isPreCheckout="isPreCheckout"
      :cart-product="cartProduct"></adv-cart-product-row>
  </div>
</template>

<script>
import store from '../../vue/store'
import AdvCartProductRow from './AdvCartProductRow'

export default {
  name: 'AdvCartProductList',
  components: {
    AdvCartProductRow
  },
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    },
    isPreCheckout: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    cartProductContents () {
      return store.getters.cartContents
    },
    getSelectedCurrency () {
      return store.getters.selectedCurrency
    }
  },
  methods: {
    removeProductFromCart () {
      store.dispatch('addToCartClicked', {
        productCodeId: this.productCodeId,
        quantity: 0
      })
    }
  }
}
</script>
